import Flex from '@eversports/react-components/primitives/Flex'
import Skeleton from '@eversports/react-components/primitives/Skeleton'
import Heading from '@eversports/react-components/primitives/Heading'
import Table, { TableBody, TableHead, TableRow } from '@eversports/react-components/primitives/Table'
import ProductTableCell from '../../Product/ProductTableCell'

const NUMBER_OF_PRODUCT_ROWS = 5
const productRows = [...Array(NUMBER_OF_PRODUCT_ROWS)]

const SkeletonProductionSelection = () => (
  <>
    <Heading is="h3" marginBottom="wide">
      <Skeleton variant="text" width="312px" height="56px" />
    </Heading>
    <Flex flexDirection="column" verticalSpacing="wide">
      <Skeleton variant="text" height="20px" width="182px" />
      <Table>
        <colgroup>
          <col width="80%" />
          <col width="5%" />
          <col width="15%" />
        </colgroup>
        <TableHead>
          <TableRow>
            <ProductTableCell>
              <Skeleton variant="text" height="20px" width="100px" />
            </ProductTableCell>
            <ProductTableCell>
              <Flex justifyContent="center">
                <Skeleton variant="text" height="20px" width="50px" />
              </Flex>
            </ProductTableCell>
            <ProductTableCell>
              <Flex justifyContent="center">
                <Skeleton variant="text" height="20px" width="50px" />
              </Flex>
            </ProductTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productRows.map((_, i) => (
            <TableRow key={i}>
              <ProductTableCell align="center">
                <Flex horizontalSpacing="default" alignItems="center">
                  <Skeleton variant="circular" width="25px" height="25px" />
                  <Skeleton variant="text" height="20px" width="100px" />
                </Flex>
              </ProductTableCell>
              <ProductTableCell>
                <Flex justifyContent="center">
                  <Skeleton variant="circular" width="20px" height="20px" />
                </Flex>
              </ProductTableCell>
              <ProductTableCell>
                <Flex justifyContent="center">
                  <Skeleton variant="text" height="20px" width="50px" />
                </Flex>
              </ProductTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Flex>
  </>
)

export default SkeletonProductionSelection
